import { Toast } from '@base-ui/react/toast';
import React, {
  PropsWithChildren,
  ReactElement,
  useCallback,
  useState
} from 'react';

import { ErrorSnackbar } from '../components/ErrorSnackbar';

export type ErrorDisplayContextValue = {
  displayError: (error: unknown) => void;
};

export const ErrorDisplayContext =
  React.createContext<ErrorDisplayContextValue>(undefined!);

type ErrorDisplayProviderProps = PropsWithChildren;

export const ErrorDisplayProvider = ({
  children
}: ErrorDisplayProviderProps): ReactElement => {
  const [errorQueue, setErrorQueue] = useState<unknown[]>([]);
  const displayError = useCallback((error: unknown) => {
    if (!error) {
      return;
    }
    setErrorQueue(prev => [...prev, error]);
  }, []);

  const handleClose = useCallback(() => {
    setErrorQueue(prev => prev.slice(1));
  }, []);

  const value = {
    displayError
  };
  return (
    <ErrorDisplayContext.Provider value={value}>
      <Toast.Provider timeout={5000} limit={1}>
        {children}
        {errorQueue.length > 0 ? (
          <ErrorSnackbar
            key={errorQueue.length}
            onClose={handleClose}
            error={errorQueue[0]}
          />
        ) : null}
      </Toast.Provider>
    </ErrorDisplayContext.Provider>
  );
};
